@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
<div class="content">
  <div class="toolbar">
    <span class="spacer"></span>
    <span>
      <label class="quantityLabel">Release Quantity: {{ totalQuantity }}</label>
      <button matButton="text" [disabled]="isBusy() || totalQuantity === 0" (click)="generateRelease()">
        <span>
          <mat-icon>done</mat-icon>
          <label>Generate Release</label>
        </span>
      </button>
    </span>
  </div>
  <div class="lineSelection">
    <h4 class="centeredCell tableHeader">Please select a line to view detail</h4>
    <table class="reportTable">
      <thead>
        <tr>
          <td class="tableCell headerCell centeredCell">Line</td>
          <td class="tableCell headerCell centeredCell">Description</td>
          <td class="tableCell headerCell centeredCell">Qty</td>
        </tr>
      </thead>
      @if (releaseLines() && releaseLines().length > 0) {
        @for (line of releaseLines(); track line) {
          <tr class="selectableRow"
            [class.lineSelectedRow]="selectedLine && line.lineId === selectedLine.lineId" (click)="selectLine(line)">
            <td class="tableCell centeredCell">{{ line.lineId }}</td>
            <td class="tableCell centeredCell">{{ line.lineDescription }}</td>
            <td class="tableCell centeredCell">{{ line.quantityToRelease }}</td>
          </tr>
        }
      }
      @if (!releaseLines() || releaseLines().length === 0) {
        <tr>
          <td class="tableCell centeredCell" colspan="3">No lines found to release</td>
        </tr>
      }
    </table>
  </div>
  @if (selectedLine && selectedLine.details) {
    <div class="lineDetail">
      <div class="toolbar">
        <span>
          @if (changeAvailable('Lt')) {
            <button matButton="text" [disabled]="isBusy()" (click)="changeSelectedTagsHand('Lt')">
              <span>
                <mat-icon>keyboard_arrow_left</mat-icon>
                <label>All Selected to Left Hand</label>
              </span>
            </button>
          }
          @if (changeAvailable('Rt')) {
            <button matButton="text" [disabled]="isBusy()" (click)="changeSelectedTagsHand('Rt')">
              <span>
                <label>All Selected to Right Hand</label>
                <mat-icon>keyboard_arrow_right</mat-icon>
              </span>
            </button>
          }
        </span>
      </div>
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell checkboxCell" (click)="toggleAllSelection()">
              <input class="ignoreClicks" type="checkbox" [checked]="allDetailsSelected()"/>
            </td>
            <td class="tableCell headerCell centeredCell">Sequence</td>
            <td class="tableCell headerCell centeredCell">Tag</td>
            <td class="tableCell headerCell centeredCell">PO Line</td>
            <td class="tableCell headerCell centeredCell">Hand</td>
          </tr>
        </thead>
        @if (selectedLine.details.length > 0) {
          @for (detail of selectedLine.details; track detail) {
            <tr class="selectableRow" [class.selectedRow]="detail.selected"
              (click)="selectDetail($event, detail)">
              <td class="tableCell centeredCell checkboxCell">
                <input type="checkbox" [checked]="detail.selected" class="ignoreClicks"/>
              </td>
              <td class="tableCell centeredCell">{{ detail.sequence }}</td>
              <td class="tableCell centeredCell wideCell">{{ detail.tagInformation.tag }}</td>
              <td class="tableCell centeredCell wideCell">{{ detail.tagInformation.poLine }}</td>
              <td class="tableCell centeredCell" (click)="$event.stopPropagation();">
                <select class="userInput" name="handSelection" [(ngModel)]="detail.hand" [disabled]="!handChangeAllowed()">
                  <option value="Lt">Left</option>
                  <option value="Rt">Right</option>
                </select>
              </td>
            </tr>
          }
        }
        @if (selectedLine.details.length === 0) {
          <tr>
            <td class="tableCell centeredCell" colspan="5">No tags found to release</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}

